// extracted by mini-css-extract-plugin
export var activeIndex = "NewLoader-module--activeIndex--fbc34";
export var bounce = "NewLoader-module--bounce--02a0f";
export var cMarginTop = "NewLoader-module--c-margin-top--ad722";
export var cPadding = "NewLoader-module--c-padding--7143e";
export var cPaddingBottom = "NewLoader-module--c-padding-bottom--4d430";
export var cPaddingTop = "NewLoader-module--c-padding-top--f9477";
export var content = "NewLoader-module--content--a3adb";
export var date = "NewLoader-module--date--c0abb";
export var disabled = "NewLoader-module--disabled--c9af2";
export var dot = "NewLoader-module--dot--2d0bb";
export var dotOne = "NewLoader-module--dotOne--b5057";
export var dotThree = "NewLoader-module--dotThree--6d372";
export var dotTwo = "NewLoader-module--dotTwo--60d12";
export var ellipsis = "NewLoader-module--ellipsis--38a4f";
export var featuredSection = "NewLoader-module--featuredSection--a3c99";
export var globalSpacing = "NewLoader-module--global-spacing--8eb69";
export var globalSpacingBottom = "NewLoader-module--global-spacing-bottom--7af04";
export var globalSpacingTop = "NewLoader-module--global-spacing-top--54c49";
export var image = "NewLoader-module--image--aaec3";
export var imageWrapper = "NewLoader-module--imageWrapper--18e5b";
export var index = "NewLoader-module--index--a64c4";
export var listItem = "NewLoader-module--listItem--8a2e1";
export var loaderCard = "NewLoader-module--loaderCard--0265a";
export var loaderMessage = "NewLoader-module--loaderMessage--17920";
export var loadingDots = "NewLoader-module--loadingDots--1f308";
export var loadingOverlay = "NewLoader-module--loadingOverlay--9baa2";
export var maxWidth = "NewLoader-module--max-width--8f488";
export var navButton = "NewLoader-module--navButton--36b56";
export var no = "NewLoader-module--no--f9552";
export var pagination = "NewLoader-module--pagination--76e7a";
export var para = "NewLoader-module--para--fff5e";
export var styleTick = "NewLoader-module--styleTick--b8e93";
export var tag = "NewLoader-module--tag--b5967";
export var tagWrapper = "NewLoader-module--tagWrapper--1e778";
export var title = "NewLoader-module--title--596b4";